import { trackEvent } from '@ubeya/shared-web/analytics/amplitude';
import { patch, post } from '../../utils/http';

export const updateSlot = ({ accountId, branchId, projectId, shiftId, slotId, slot, src }) =>
  patch(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/slots/${slotId}?src=${src}`,
    slot
  );

export const changeShiftInternalEmployee = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  slotId,
  destShiftId,
  withValidations
}) =>
  patch(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/slots/${slotId}/change-shift`,
    {
      destShiftId,
      withValidations
    }
  );

export const updateConfirmationSlot = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  slotId,
  confirmationId,
  isConfirmed
}) =>
  patch(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/slots/${slotId}/confirmations/${confirmationId}`,
    { isConfirmed }
  );

export const moveSlot = ({
  accountId,
  branchId,
  projectId,
  shiftId,
  slotId,
  dst,
  markAsOpenShift,
  decreaseNeeded,
  bookToLinkedShifts,
  bypassComplianceWarnings
}) => {
  trackEvent('Scheduling Board - Move Slot', {
    accountId,
    branchId,
    projectId,
    shiftId,
    slotId,
    dst,
    markAsOpenShift,
    decreaseNeeded,
    bookToLinkedShifts
  });
  return post(
    `/accounts/${accountId}/branches/${branchId}/projects/${projectId}/shifts/${shiftId}/slots/${slotId}/move`,
    {
      dst,
      markAsOpenShift,
      decreaseNeeded,
      bookToLinkedShifts,
      bypassComplianceWarnings
    }
  );
};
